export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"hid":"description","name":"description","content":"The Allard Pierson Museum is the archaeological museum of the University of Amsterdam."}],"link":[{"rel":"preconnect","href":"//www.google-analytics.com"},{"rel":"preconnect","href":"//www.googletagmanager.com"},{"rel":"preconnect","href":"//fonts.googleapis.com"},{"rel":"preconnect","href":"//fonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"//fonts.googleapis.com/css2?family=Lusitana:wght@400;700&display=swap"},{"rel":"icon","type":"image/x-icon","href":"/favicons/favicon.ico"}],"style":[{"hid":"css-variables","children":":root { --font-family-primary:Lusitana;--font-family-secondary:DIN Condensed;--font-size-xs:1rem;--font-size-sm:1.125rem;--font-size-md:1.25rem;--font-size-lg:1.375rem;--font-size-xl:1.5rem;--font-size-xxl:1.625rem;--font-size-2xl:1.75rem;--font-size-3xl:1.875rem;--font-size-4xl:2rem;--font-size-5xl:2.125rem;--font-size-6xl:2.25rem;--font-size-7xl:2.5rem;--font-size-8xl:2.875rem;--font-size-9xl:3.25rem;--font-size-10xl:3.375rem;--font-size-11xl:3.875rem;--font-size-12xl:4rem;--font-size-13xl:4.5rem;--font-size-14xl:5.25rem;--font-size-15xl:6.75rem;--font-weight-primary-normal:400;--font-weight-primary-bold:700;--font-weight-secondary-bold:700;--lineHeight-xs:.9;--lineHeight-sm:1;--lineHeight-md:1.1;--lineHeight-lg:1.15;--lineHeight-xl:1.2;--lineHeight-xxl:1.25;--grid-side-gap-sm:1rem;--grid-side-gap-md:var(--grid-gap-md);--grid-side-gap-lg:3.75rem;--grid-gap-sm:var(--spacing-md);--grid-gap-md:var(--spacing-xl);--grid-gap-lg:var(--spacing-xxl);--grid-maxWidth-page:90rem;--grid-maxWidth-content:53.75rem;--spacing-xs:.75rem;--spacing-sm:1.25rem;--spacing-md:1.5rem;--spacing-lg:2rem;--spacing-xl:3rem;--spacing-xxl:3.75rem;--spacing-2xl:5rem;--borderRadius-sm:0.125rem;--borderRadius-md:0.25rem;--borderRadius-lg:0.5rem;--borderRadius-xl:0.75rem;--borderRadius-full:9999px;--boxShadow-light:0px 0px 8px rgba(0, 0, 0, 0.06);--boxShadow-base:0px 0px 6px rgba(0, 0, 0, 0.16);--boxShadow-medium:0px 0px 11px rgba(0, 0, 0, 0.20);--boxShadow-heavy:0px 0px 16px rgba(0, 0, 0, 0.24);;--boxShadow-outline:0 0 0 3px rgba(66, 153, 225, 0.5);--boxShadow-inset:inset 1px 1px 4px rgba(0, 0, 0, 0.12);--color-darkest:#000;--color-lightest:#fff;--color-blue:#B2E8FF;--color-brown:#4D1700;--color-pink:#FFC0CB;--color-teal:#00402B;--color-yellow:#FFF59F;--color-dark-blue:#010A5C;--color-green:#BDFFB2;--color-purple:#42004D;--color-primary:#B2E8FF;--color-primary-light:#F3FBFF;--color-primary-dark:#46C8FF;--color-secondary:#4D1700;--color-secondary-light:#551900;--color-secondary-dark:#3A1100;--color-gray-200:#f2f2f2;--color-gray-300:#cacaca;--color-gray-600:#565656;--color-gray-800:#333333;--color-highlight-success:#1EAC70;--color-highlight-info:lightblue;--color-highlight-warning:orange;--color-highlight-error:#DF3755;--transition-timing-slow:1s;--transition-timing-medium:500ms;--transition-timing-fast:150ms;--transition-timingFunction-in:cubic-bezier(0.4, 0, 1, 1);--transition-timingFunction-out:cubic-bezier(0, 0, 0.2, 1);--transition-timingFunction-in-out:cubic-bezier(0.4, 0, 0.2, 1);--transition-fast:var(--transition-timing-fast) 0ms var(--transition-timingFunction-in);--transition-medium:var(--transition-timing-medium) 0ms var(--transition-timingFunction-in);--transition-slow:var(--transition-timing-slow) 0ms var(--transition-timingFunction-in);--transition-colorTheme:background-color 400ms 0ms ease; }","type":"text/css"}],"script":[],"noscript":[],"title":"Allard Pierson"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false